import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Dot, MoveRight } from "lucide-react";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";

interface IDate {
  date: string;
  datePrefix: string;
  description: string;
}
export const Timeline = ({ dates }: { dates: IDate[] }) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1280px)" });
  const swiperRef = useRef<SwiperCore | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setActiveIndex(swiperRef.current.activeIndex);
    }
  };
  // return(<div>Timeline</div>)
  return (
    <div className="py-10" id="timeline">
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
        slidesPerView={isTabletOrMobile ? 1.2 : 1.8}
        speed={800}
        spaceBetween={20}
      >
        {dates.map((item: IDate, index: number) => (
          <SwiperSlide
            key={`date-${index}-${item.date}`}
            className="self-stretch overflow-visible pb-10 cursor-move"
            style={{ height: `auto` }}
          >
            <div className="relative h-full grid grid-cols-1 xl:grid-cols-6 gap-2 _w-8/12 _border _border-gray-200 p-0 grow border-b border-b-brand-red pb-8 overflow-visible">
              <div className="absolute -bottom-4 -left-3 flex bg-white pr-4">
                <Dot size={32} className="text-brand-red" />
                <MoveRight
                  size={32}
                  strokeWidth={1.75}
                  className="text-brand-blue"
                />
              </div>

              <div className="col-span-6 xl:col-span-2 text-brand-blue">
                {item.datePrefix && (
                  <div className="text-3xl font-bold">{item.datePrefix}</div>
                )}
                {item.date && (
                  <div className="text-3xl font-bold">{item.date}</div>
                )}
              </div>

              <div className="col-span-6 xl:col-span-4 border-l-4 border-l-gray-200">
                {item.description && (
                  <p className="text-sm text-gray-800 font-light pl-4">
                    {item.description}
                  </p>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
        {/* <SwiperSlide
          className="self-stretch overflow-visible pb-10 cursor-move"
          style={{ height: `auto` }}
        >
          <></>
        </SwiperSlide> */}
      </Swiper>
      <div className="hidden xl:flex space-x-2">
        {dates.map((item: IDate, index) => (
          <button
            key={index}
            onClick={() => swiperRef.current?.slideTo(index)}
            className={clsx(
              "px-1.5 py-1.5 text-sm border-b-2 border-transparent",
              index === activeIndex && "text-brand-red border-b-brand-red"
            )}
          >
            {item.date}
          </button>
        ))}
      </div>
    </div>
  );
};
